import { useMemo } from "react";
import { useAuth } from "@/lib/AuthContext";
import { can as canDo, normaliseRole } from "../roles";

/**
 * The CRM role of the signed-in user, read from `tenant_role` on `/auth/me`
 * (contract "Team": `GET /api/crm/me` and `/auth/me` both carry it).
 *
 * FAILS CLOSED: a session whose payload carries no role, or a role this build does not
 * know, is treated as `helper`. Showing an owner-only control to a helper is a 403 on
 * click; hiding one from an owner whose payload lost the field is an honest omission.
 *
 * @returns {{role: "owner"|"helper", isOwner: boolean, can: (action: string) => boolean}}
 */
export default function useRole() {
  const { user } = useAuth();
  const role = normaliseRole(user?.tenant_role);
  return useMemo(() => ({
    role,
    isOwner: role === "owner",
    can: (action) => canDo(role, action),
  }), [role]);
}
